


/**
 * @param {InterstitialController.$Scope} $scope
 * @param {ng.IQService} $q
 * @param {import("core-services/subscription.service").SubscriptionService} SubscriptionService
 */
export function InterstitialController(
  $scope,
  $q,
  SubscriptionService,
) {

  $scope.isStartTrialPending = false;

  $scope.form = {
    acceptsTermsOfService: false
  };

  $scope.planInfo = {
    hasTrial: false,
    trialLengthInDays: 0,
  };

  $scope.manageSubscriptionWasClicked = function(event) {
    event.preventDefault();
    $scope.isStartTrialPending = true;

    return $q.when(SubscriptionService.fetchSubscriptionManagementStrategy())
      .then(result => SubscriptionService.manageSubscription(result));
  };

  SubscriptionService.plan$.subscribe(plan => {
    $scope.planInfo.hasTrial = plan.trialPeriodDays > 0;
    $scope.planInfo.trialLengthInDays = plan.trialPeriodDays;
  });
};

export default ['$scope', '$q', 'SubscriptionService', InterstitialController];

// import { SubscriptionService } from './user/subscription.service';


// export interface InterstitialController {
//   (
//     $scope: IScope,
//     SubscriptionService: SubscriptionService,
//     stripe,
//   ): void;
// }


/**
 * @typedef {object} InterstitialController.PlanInfo
 * @property {boolean} hasTrial
 * @property {number} trialLengthInDays
 */

/**
 * @typedef {object} InterstitialController.MyScope
 * @property {{ acceptsTermsOfService: boolean }} form
 * @property {InterstitialController.PlanInfo} planInfo
 * @property {() => void} manageSubscriptionWasClicked
 * @property {boolean} isStartTrialPending
 */

/**
 * @typedef {ng.IScope & InterstitialController.MyScope} InterstitialController.$Scope
 */
